// extracted by mini-css-extract-plugin
var _1 = "header-yanqY";
export { _1 as "header" }
